export default "/_next/static/images/3-ad77a2962233a6ee0cf8d1348fe8c8c1.png";